import React, { useState, useEffect, useRef, useCallback } from 'react';

export const MobileCarousel = ({ children, autoPlayInterval = 4000 }) => {
  const items = React.Children.toArray(children);
  const [current, setCurrent] = useState(0);
  const [paused, setPaused] = useState(false);
  const containerRef = useRef(null);
  const touchStartX = useRef(0);

  const next = useCallback(() => setCurrent(prev => (prev + 1) % items.length), [items.length]);

  useEffect(() => {
    if (paused) {
      const resume = setTimeout(() => setPaused(false), 8000);
      return () => clearTimeout(resume);
    }
    const timer = setInterval(next, autoPlayInterval);
    return () => clearInterval(timer);
  }, [paused, next, autoPlayInterval]);

  const handleTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const handleTouchEnd = (e) => {
    const diff = touchStartX.current - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 40) {
      setPaused(true);
      if (diff > 0) setCurrent(prev => (prev + 1) % items.length);
      else setCurrent(prev => (prev - 1 + items.length) % items.length);
    }
  };

  return (
    <div className="md:hidden">
      <div
        ref={containerRef}
        className="overflow-hidden"
        onTouchStart={handleTouchStart}
        onTouchEnd={handleTouchEnd}
      >
        <div
          className="flex transition-transform duration-500 ease-out"
          style={{ transform: `translateX(-${current * 100}%)` }}
        >
          {items.map((child, i) => (
            <div key={i} className="w-full flex-shrink-0 px-2">
              {child}
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-center gap-1.5 mt-5">
        {items.map((_, i) => (
          <button
            key={i}
            onClick={() => { setPaused(true); setCurrent(i); }}
            className={`h-2 rounded-full transition-all ${i === current ? 'w-6 bg-[#ba2a84]' : 'w-2 bg-gray-300'}`}
          />
        ))}
      </div>
    </div>
  );
};
